import { AbstractControl } from "@angular/forms";

export function argentinianTaxCodeValidator(control: AbstractControl): { format?: boolean } | null {
	const value = String(control.value);
	const taxCodeRegex = /^\d{2}-\d{7,8}-\d$/;

	if (value.match(taxCodeRegex)) {
		return null;
	}

	return { format: false };
}
